// Mock data for Arranque Express BCN
export const mockData = {
  // Contact info - to be filled later
  contacts: {
    whatsapp: "+34613076099", // Updated number
    phone: "+34 XXX XXX XXX", // To be provided
    email: "info@arranqueexpressbcn.com" // To be provided
  },
  
  // Pricing
  pricing: {
    day: {
      price: 69,
      hours: "8:00 - 22:00",
      days: "Lunes a Viernes"
    },
    night: {
      price: 89,
      hours: "22:00 - 8:00",
      days: "Noches"
    },
    weekend: {
      price: 99,
      hours: "Todo el día",
      days: "Sábados y Domingos"
    },
    nightWeekend: {
      price: 99,
      hours: "22:00 - 8:00 / Fines de semana",
      days: "Noches y Sábados/Domingos"
    }
  },
  
  // Payment methods
  paymentMethods: [
    { name: "Bizum", icon: "smartphone" },
    { name: "Tarjeta", icon: "credit-card" },
    { name: "Efectivo", icon: "banknote" }
  ],
  
  // Service areas
  zones: [
    { name: "Barcelona Ciudad", supplement: 0, description: "Todos los barrios de Barcelona" },
    { name: "Área Metropolitana", supplement: 0, description: "L'Hospitalet, Badalona, Santa Coloma..." },
    { name: "Aeropuerto El Prat", supplement: 25, description: "Terminales T1 y T2, parkings" }
  ],
  
  // How it works steps
  howItWorks: [
    {
      step: 1,
      title: "Llámanos o escríbenos",
      description: "Contacta por WhatsApp o teléfono. Te respondemos al instante."
    },
    {
      step: 2, 
      title: "Nos desplazamos",
      description: "Llegamos hoy mismo con equipo profesional."
    },
    {
      step: 3,
      title: "Arrancamos tu coche",
      description: "Servicio profesional. Pagas cuando tu coche funciona."
    }
  ],
  
  // FAQ
  faq: [
    {
      question: "¿Cuánto tardáis en llegar?",
      answer: "Llegamos lo más rápido posible, dependiendo del tráfico y tu ubicación en Barcelona. Nuestro objetivo es estar contigo cuanto antes."
    },
    {
      question: "¿Qué formas de pago aceptáis?",
      answer: "Aceptamos Bizum, tarjeta de crédito/débito y efectivo."
    },
    {
      question: "¿Trabajáis los fines de semana?",
      answer: "Sí, trabajamos 24/7 incluidos fines de semana y festivos."
    },
    {
      question: "¿El precio incluye el desplazamiento?",
      answer: "Sí, el precio es fijo e incluye desplazamiento dentro de Barcelona ciudad."
    },
    {
      question: "¿Qué pasa si no conseguís arrancar el coche?",
      answer: "Si no conseguimos arrancar tu coche, no pagas nada. Garantía total - 100% reembolsado."
    },
    {
      question: "¿Funciona con coches eléctricos?",
      answer: "Sí, si es la batería auxiliar (12V) la que falla. Si es la batería de tracción, recomendamos contactar con asistencia especializada."
    }
  ],
  
  // Company info
  company: {
    name: "ArrancaYa BCN",
    tagline: "Arrancamos tu coche en Barcelona",
    slogan: "Más rápido que tu seguro, más económico que una grúa",
    description: "Servicio profesional de arranque de vehículos a domicilio en Barcelona",
    logo: "/images/logo.png",
    heroImage: "/images/hero-arranque.jpg",
    keyPoints: [
      "Arrancamos todo tipo de coche, llegamos con batería portátil profesional y solo pagas si tu coche arranca",
      "No necesitas grúa ni esperar horas: venimos en scooter con una batería portátil profesional y arrancamos tu coche en minutos",
      "No cambiamos la batería, simplemente arrancamos tu vehículo",
      "Si no conseguimos arrancar tu coche, no pagas nada - 100% garantizado",
      "El desplazamiento es gratuito"
    ],
    features: [
      "Servicio 24/7",
      "Precio fijo",
      "Profesionales cualificados",
      "Cobertura Barcelona ciudad",
      "Garantía 100% - Si no arranca, no pagas"
    ],
    futureService: {
      title: "Próximamente: Cambio de batería",
      description: "Próximamente, nuestro técnico podrá cambiar la batería si tu vehículo la necesita y es compatible con nuestra batería estándar.",
      price: "150€ (incluye desplazamiento, batería e instalación)"
    }
  },

  // Car brands for scrolling banner
  carBrands: [
    "Audi", "BMW", "Mercedes", "Volkswagen", "Ford", "Renault", "Peugeot", 
    "Citroën", "Opel", "Nissan", "Toyota", "Hyundai", "Kia", "Seat", 
    "Skoda", "Fiat", "Alfa Romeo", "Volvo", "Mazda", "Honda"
  ],

  // Barcelona images
  barcelonaImages: [
    "https://images.unsplash.com/photo-1583422409516-2895a77efded?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxCYXJjZWxvbmElMjBjaXR5fGVufDB8fHx8MTc1Nzg1MjI1Mnww&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/1388030/pexels-photo-1388030.jpeg",
    "https://images.unsplash.com/photo-1731266955612-67dab3692dfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxCYXJjZWxvbmElMjBzdHJlZXRzfGVufDB8fHx8MTc1Nzg1MjI2MHww&ixlib=rb-4.1.0&q=85"
  ]
};